import { render, staticRenderFns } from "./SelectGVS.vue?vue&type=template&id=75461184&scoped=true&"
import script from "./SelectGVS.vue?vue&type=script&lang=js&"
export * from "./SelectGVS.vue?vue&type=script&lang=js&"
import style0 from "./SelectGVS.vue?vue&type=style&index=0&id=75461184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75461184",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
